import { render, staticRenderFns } from "./product-category-select.vue?vue&type=template&id=6e4f1196&scoped=true&"
import script from "./product-category-select.vue?vue&type=script&lang=ts&"
export * from "./product-category-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f1196",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4f1196')) {
      api.createRecord('6e4f1196', component.options)
    } else {
      api.reload('6e4f1196', component.options)
    }
    module.hot.accept("./product-category-select.vue?vue&type=template&id=6e4f1196&scoped=true&", function () {
      api.rerender('6e4f1196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/product-category-select.vue"
export default component.exports